import get from 'lodash-es/get';

export default namespaceSettings =>
  get(namespaceSettings, 'config.historyArchivalState', '');



// WEBPACK FOOTER //
// ./client/routes/namespace/workflow-archival/helpers/get-history-archival-state.js